export default __webpack_public_path__ + "static/media/ManureSpreader.d4bdc97f.jpg";